import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { available: Boolean };

  availableValueChanged() {
    this.dispatch('changed', { detail: { available: this.availableValue } });
  }
}
